import { finish, error } from '../../../modules/audits/actions/query';
import api from '../../../api';
import moment from 'moment';
import { autorun } from 'src_common/common/mobx-wrapper';

const getAuditType = (type) => {
    if (type.includes('event')) {
        return 'EventIdEqual';
    }
    if (type.includes('market')) {
        return 'MarketIdEqual';
    }
    if (type.includes('selection')) {
        return 'SelectionIdEqual';
    }

    return undefined;
};



function getSelectionIdFromString(value) {
    const split = value.split('-');
    return split[split.length - 1];
}

export async function request(dispatch, action) {
    const q = {
        perPage: 100,
        aggregations: {}
    };

    q.aggregations = {};
    if (!action.data.topics.includes('trading_content') ) {
        q.aggregations.total = { type: 'count' };
    }
    const auditsValue = $appState.routerBackoffice.getValueString('audits');
    const eventIdNew = $appState.routerBackoffice.getValueString('events');
    const selectionIdNew = auditsValue.includes('trading_content_selection-change') ? getSelectionIdFromString(auditsValue) : undefined;
    const marketIdNew = auditsValue.includes('trading_content_market-change') ? getSelectionIdFromString(auditsValue) : $appState.routerBackoffice.routerReduxState.data.events?.parameters.market;

    // TODO: remove after refactor audit component
    if (eventIdNew !== null) {
        const eventId = $appState.sdkStaff.models.id
            .getEventId(parseInt(eventIdNew, 10));

        const marketId = marketIdNew !== undefined ? eventId.getMarketId(parseInt(marketIdNew, 10)) : undefined;

        const selectionId = marketId !== undefined && selectionIdNew !== undefined ? marketId.getSelectionId(parseInt(selectionIdNew, 10)) : undefined;

        const eventModel = await eventId.getEventModelAsync();
        const marketModel = marketId !== undefined ? await marketId.getModelAsync() : undefined;
        const selectionModel = selectionId !== undefined ? await selectionId.getModelAsync() : undefined;
    
        q.eventId = eventModel.getData().idv2;
        q.marketId = marketModel !== undefined ? marketModel.getData().idv2 : undefined;
        q.selectionId = selectionModel !== undefined ? selectionModel.getData().idv2 : undefined;
    }

    q.perPage = action.data.perPage || 100;
    q.page = action.data.page || 1;
    q.topics = action.data.topics || [];
    q.tags = action.data.tags || [];
    q.from = action.data.from ? action.data.from : moment().subtract(48, 'hours').format('YYYY-MM-DDT00:00:00');
    q.to = action.data.to  ? action.data.to : moment().format('YYYY-MM-DDT23:59:59');

    q.idv2 = action.id;
    q.type = getAuditType(action.id);
    q.from = new Date(q.from).toISOString();
    q.to = new Date(q.to).toISOString();

    if (eventIdNew === null) {
        // REQUEST FOR ACCOUNT AUDIT
        api.post('/audits/search', q).then(
            (audits) => {
                dispatch(finish(action.id, q, audits));
            },
            (errors) => {
                console.log('errors', errors);
                dispatch(error(action.id, errors));
            }
        );
        return;
    }
    
    // REQUEST FOR EVENT MARKET AND SELECTION AUDIT
    $appState.sdkStaff.auditEvent({requestBody: q}).then(
        (audits) => {
            dispatch(finish(action.id, q, audits));
        },
        (errors) => {
            console.log('errors', errors);
            dispatch(error(action.id, errors));
        }
    );
}
